/*
 * See the file LICENSE for the full license governing this code.
 */

import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';

export default function Loader({ style }) {
  return (
    <Grid
      style={{ height: '100%', ...style }}
      container
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress />
    </Grid>
  );
}
